package com.flowyride.core.domain.model

enum class Level { LOW, NORMAL, HIGH }

/**
 * What the rider wants from the ride. Engines map these to their own knobs
 * and may ignore the ones they cannot honour.
 */
data class RoutePreferences(
    /** NORMAL matches BMW Motorrad Connected's default "winding" routes (same TomTom engine). */
    val windingness: Level = Level.NORMAL,
    val hilliness: Level = Level.NORMAL,
    val avoidMotorways: Boolean = true,
)

/** What the route is for. */
enum class RouteStyle {
    /** A ride: winding roads ([RoutePreferences] apply). */
    WINDING,

    /** Getting somewhere quickly, e.g. back onto the planned ride after leaving it. */
    FASTEST,
}

data class RouteRequest(
    /** Ordered stops: first is the departure, last is the arrival. */
    val waypoints: List<GeoPoint>,
    val preferences: RoutePreferences = RoutePreferences(),
    val style: RouteStyle = RouteStyle.WINDING,
    /** Direction the rider is heading at the departure (degrees, 0 = north): avoids U-turns. Null when unknown. */
    val initialHeading: Double? = null,
) {
    init {
        require(waypoints.size >= 2) { "A route needs at least a departure and an arrival" }
    }
}
